export default __webpack_public_path__ + "static/media/loading.d5e1748c.gif";